import { render, staticRenderFns } from "./addPromotionGoods.vue?vue&type=template&id=2b5d943b&scoped=true&"
import script from "./addPromotionGoods.vue?vue&type=script&lang=js&"
export * from "./addPromotionGoods.vue?vue&type=script&lang=js&"
import style0 from "./addPromotionGoods.vue?vue&type=style&index=0&id=2b5d943b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5d943b",
  null
  
)

export default component.exports